<div class="smooth-scrolling">

  <div class="top-breadcrunbs">
    <ul>
      <li><a (click)="backClick()"><img src="assets/images/back-arrow.svg" alt=""></a></li>
      <li class="breadcrumb-item"><a routerLink="/home-page">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/shop-all">Shop All</a></li>
      <li class="breadcrumb-item"><a (click)="brandNameClick(mProductModal?.brand)">{{ mProductModal?.brand?.name?.length ?? 0 > 20 ? (mProductModal?.brand?.name | slice:0:20) + '...' : mProductModal?.brand?.name }}</a></li>
      <li class="breadcrumb-item" aria-current="page"><a>{{mProductModal.name?.length ?? 0 > 20 ? (mProductModal.name | slice:0:20) + '...' :mProductModal.name }}</a></li>
    </ul>
  </div>

  <!-- single-product-section START -->
  <div class="single-product-section">
    <div class="container">
      <div class="row">
        <div class=" col-lg-6 col-12 product-imgs">
          <div class="product-desc ">
            <div class="heading product-none-d">
              <div class="sml-title"> <a (click)="brandNameClick(mProductModal?.brand)">
                  {{mProductModal?.brand?.name}}</a></div>
              <div class="product-name">
                <h1 *ngIf="mProductModal && mProductModal.extras && mProductModal.extras.length > 0">{{selectedProductExtra.name}}</h1>
                <h1 *ngIf="mProductModal.extras && mProductModal.extras.length < 1">{{mProductModal.name}}</h1>
              </div>
            </div>
          </div>
          <!-- Carousel Start -->
          <div id="carouselsliderdemo" class="carousel slide" data-bs-ride="carousel">
            <!-- Indicator start -->
            <div class="carousel-indicators order-lg-1 order-2">
              <button type="button" id="productThumbImage_{{i}}" data-bs-target="#carouselsliderdemo"
                class="img-thumbnail" data-bs-slide-to="0" *ngFor="let productImage of colorImageChange; let i = index"
                (click)="productThumbnailClick(i)">
                <span class="thumbnail-bg-gradient">
                  <span class="bg-white-btn-t"><img appPreLoading
                      [lazyLoad]="productImage?.path ? productImage?.path : 'assets/images/default-product.png'" alt=""
                      class="d-block w-100"></span>
                </span>
              </button>
            </div>
            <!-- Indicator Close -->
            <div class="carousel-inner order-lg-2 order-1">
              <div class="carousel-item" id="productImage_{{i}}"
                *ngFor="let productImage of colorImageChange; let i = index">
                <img appPreLoading
                  [lazyLoad]="productImage?.path ? productImage?.path : 'assets/images/default-product.png'"
                  class="d-block w-100">
              </div>
              <div class="bottom-btn d-none justify-content-center">
                <img src="assets/images/try-this-shade-icon.svg" alt="icon">
                <span>try this shade on Me</span>
              </div>
            </div>
          </div>

          <div class="expiry-date-text d-none d-lg-flex">

            <div class="c-of-origin">
              <span>country of origin:&nbsp;</span>
              <span>{{mProductModal?.country_of_origin}}</span>
            </div>
            <div class="e-date">
              <span>Expiry Date:&nbsp;</span>
              <span>{{mProductModal?.expiry_date}}</span>
            </div>
          </div>
        </div>
        <div class=" col-lg-6 col-12 product-desc ">
          <div class="pro-desc-wrap">
            <div class="heading product-none-m">
              <div class="sml-title"><a (click)="brandNameClick(mProductModal?.brand)"> {{mProductModal?.brand?.name}}
                </a></div>
              <div class="product-name">
                <h1 *ngIf="mProductModal && mProductModal.extras && mProductModal.extras.length > 0">{{selectedProductExtra.name}}</h1>
                <h1 *ngIf="mProductModal.extras && mProductModal.extras.length < 1">{{mProductModal.name}}</h1>
              </div>
            </div>
            <!-- size start -->
            <div class="size-price">
              <div *ngIf="mProductModal && mProductModal.extras && mProductModal.extras.length > 0"
                class="product-size">
                <label class="s-title">size:</label>
                <div class="size-detail-scroll scrollbar-width-none">
                  <div *ngFor="let extra of mProductModal.extras; let i = index" class="sizebox"
                    (click)="clickProductSize(extra)">
                    <label [ngClass]="selectedSize == extra.id ? 'active' : ''"
                      [ngStyle]="{'background-color':(selectedSize == extra.id && mProductModal?.category?.color) ? mProductModal?.category?.color : '','border':(selectedSize == extra.id && mProductModal?.category?.color) ? '1px solid '+mProductModal?.category?.color+'' : '1px solid #000'}">
                      <span>{{extra.size}}</span>
                    </label>
                  </div>
                </div>
              </div>

              <!-- size END -->

              <div *ngIf="mProductModal && mProductModal.extras && mProductModal.extras.length > 0"
                class="product-price">
                <div class="d-lg-none d-flex">
                  <div class="discount-off" *ngIf="discountApplied > 0">
                    <span>{{getDiscountShow(mProductModal)}}</span>
                  </div>
                </div>
                <div class="mobile-price">
                  <div class="main-price" *ngIf="discountApplied > 0">
                    ₹ {{selectedProductExtra.your_price}}
                  </div>
                  <div class="discount-price">
                    <span class="rupes-icon">₹</span>
                    {{getNewProductPrice(mProductModal)}}
                  </div>
                  <div class="discount-off d-lg-flex d-none" *ngIf="discountApplied > 0">
                    <span>{{getDiscountShow(mProductModal)}}</span>
                  </div>
                </div>
              </div>

              <div *ngIf="mProductModal.extras && mProductModal.extras.length < 1" class="product-price">
                <div class="d-lg-none d-flex">
                  <div class="discount-off" *ngIf="discountApplied > 0">
                    <span>{{getDiscountShow(mProductModal)}}</span>
                  </div>
                </div>
                <div class="mobile-price">
                  <div class="main-price" *ngIf="discountApplied > 0">
                    ₹ {{mProductModal.your_price}}
                  </div>
                  <div class="discount-price">
                    <span class="rupes-icon">₹</span>
                    {{getNewProductPrice(mProductModal)}}
                  </div>
                  <div class="discount-off d-lg-flex d-none" *ngIf="discountApplied > 0">
                    <span>{{getDiscountShow(mProductModal)}}</span>
                  </div>
                </div>
              </div>

            </div>
            <div class="product-info show-content">
              <span class="detail-text" *ngIf="mProductModal && mProductModal.extras && mProductModal.extras.length > 0" [innerHTML]="selectedProductExtra?.description"></span>
              <span class="detail-text" *ngIf="mProductModal.extras && mProductModal.extras.length < 1" [innerHTML]="mProductModal?.description"></span>
              <span><a (click)="scroll()" class="see-more">See More</a></span>
            </div>
            <div class="product-actions d-none d-lg-flex">
              <div class="quantity-detail">
                <span class="quantity">Quantity:</span>
                <div class="q-wrap">
                  <button type="button" id="sub" class="q-sub" (click)="removeCartItem()">-</button>
                  <input class="q-count" type="text" [(ngModel)]="mAddUpdateCartModule.qty" disabled />
                  <button type="button" id="add" class="q-add" (click)="addCartItem()">+</button>
                </div>
              </div>
            </div>
            <!-- mobile section Start  -->

            <!-- shades mobile section start  -->
            <div class="row d-lg-none d-flex">
              <div class="col-12">
                <div class="mobile-shades-detail">
                  <div class="beach-lease" *ngIf="colorList.length > 0">
                    <ng-container *ngFor="let color of colorList; let i = index">
                      <span *ngIf="i < 3" [ngClass]="activeColorId == color.id ? 'active' : ''"
                        (click)="selectColor(color)">
                        <div class="beach-lease-color" [ngStyle]="{'background': '' + color.color + ''}"></div>
                        <div class="brach-h" *ngIf="color && color.color != null">
                          {{color.color_name}}
                        </div>
                        <div class="brach-h" *ngIf="color && color.color == null">
                          No color
                        </div>
                      </span>
                    </ng-container>
                    <span (click)="selectColor('')" *ngIf="colorList && colorList.length > 3">
                      <div class="beach-lease-color view-all btn btn-primary" [ngStyle]="{'background': '#fff'}"
                        type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasBottom"
                        aria-controls="offcanvasBottom">
                        <div class="view-all-label">
                          View All
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-actions d-lg-none d-flex">
              <div class="quantity-detail">
                <span class="quantity">Quantity:</span>
                <div class="q-wrap">
                  <button type="button" id="sub" class="q-sub" (click)="removeCartItem()">-</button>
                  <input class="q-count" type="text" [(ngModel)]="mAddUpdateCartModule.qty" disabled />
                  <button type="button" id="add" class="q-add" (click)="addCartItem()">+</button>
                </div>
              </div>
            </div>
            <!-- slider shades start -->
            <div class="col-12 d-lg-block d-none" *ngIf="colorList && colorList.length > 0">
              <div class="slider-shades-header">
                <span>SHADES({{colorList.length}})</span>
              </div>
            </div>
            <div class="col-12 d-lg-block d-none" *ngIf="colorList && colorList.length > 0">
              <div class="row justify-start">
                <div class="main-selected-color main-colorpattern-color col-4">
                  <span [ngStyle]="{'background': '' + selectedProductExtra?.color + ''}"></span>
                  <small>{{selectedProductExtra?.color_name}}</small>
                </div>
                <div class="col-8 col-color-list">
                  <ul class="list-color">
                    <li *ngFor="let color of colorList; let i = index" (click)="selectColor(color)"
                      [ngClass]="activeColorId == color.id ? 'active' : ''"
                      [ngStyle]="{'background': '' + color.color + ''}">
                    </li>
                  </ul>
                </div>
              </div>
            </div>


          </div>
          <div class="expiry-date-text d-lg-none d-flex">
            <span>country of origin: {{mProductModal?.country_of_origin}}</span>
            <small>expiry date: {{mProductModal?.expiry_date}}</small>
          </div>
          <div class="product-actions product-padding">
            <div class="like-btn new-like-btn" *ngIf="!presentWishlist" (click)="addtoCart(mProductModal,'wishList')"
              [style]="'background-color: '+mProductModal?.category?.color+';'">
              <i class="fa-regular fa-heart" style="color: #ffffff;"></i>
            </div>
            <div *ngIf="presentWishlist" class="like-btn new-like-btn" (click)="addtoCart(mProductModal,'wishList')"
              style="background-color: #fff;">
              <i class="fa-solid fa-heart" [style]="'color: '+mProductModal?.category?.color+';'"></i>
            </div>
            <div class="add-to-by-now-btn">
              <a class="buy-now new-buy-now" [style]="'color: '+mProductModal?.category?.color+';'" style
                (click)="buyNow(mProductModal)"> Buy Now</a>
              <a class="add-to-cart new-add-to-cart" [style]="'background-color:'+mProductModal?.category?.color+';'"
                (click)="addtoCart(mProductModal,'cart')"><span><img src="assets/images/Plus-icon.svg" alt=""></span>
                Add to cart</a>
            </div>
          </div>
          <div class="shopping-details"
            *ngIf="website_product_configuration && website_product_configuration.length > 0">
            <div class="authentic-detail" *ngFor="let wpc of website_product_configuration; let i = index;">
              <img [src]="wpc.image" alt="icon">
              <span> {{wpc.value}} </span>
            </div>
          </div>
          <div class="offers-section-detail">
            <owl-carousel-o class="categories-slider arrow-bg-remove" [options]="offersSlider ">
              <ng-template carouselSlide *ngFor="let discount of discountList; let i = index">
                <div class="offer-details">
                  <div class="number-detail">
                    <img src="/assets/images/offers-icon.svg" alt="icon">
                    <div class="offer-details-text">
                      <small>Offers</small>
                      <span [innerHTML]="discount?.description"></span>
                    </div>
                  </div>
                  <div class="number-slider">
                    <span>{{i+1}}/{{discountList.length}}</span>
                  </div>
                </div>
              </ng-template>
            </owl-carousel-o>
            <div class="owl-counter"></div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- single-product-section END -->
  <!-- highlights section start  -->
  <section class="highlights dis-none" *ngIf="highLights && highLights.length > 0">
    <div class="row justify-content-center">
      <h5>Highlights</h5>
      <div class="col-lg-6 col-8">
        <div class="highlights-detail" [ngStyle]="{'overflow-x': highLights.length >= 3 ? 'auto' : '', 'justify-content': highLights.length <=3 ? 'center': ''}">
          <div class="col-3" *ngFor="let highlight of highLights; let i = index">
            <div class="skin-types-color">
              <div class="skin-types-color-img">
                <img appPreLoading
                  [lazyLoad]="highlight.imageList && highlight.imageList.length > 0 && highlight.imageList[0].path"
                  alt="img">
              </div>
              <span>{{highlight?.title}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- mobile section Start  -->
  <section class="highlights d-lg-none d-flex" *ngIf="highLights && highLights.length && recommends.length > 0">
    <div class="row justify-content-center highlight-new w-100">
      <div class="recommendations-t-2">
        <h5>Highlights</h5>
        <span><a (click)="mRecommendation()">Foy Recommendations</a></span>
      </div>
      <div class="col-lg-6 col-12">
        <div class="highlights-detail" [ngStyle]="{'overflow-x': highLights.length >= 3 ? 'auto' : '', 'justify-content': highLights.length <=3 ? 'center': ''}">
          <div class="col-3" *ngFor="let highlight of highLights; let i = index">
            <div class="skin-types-color">
              <div class="skin-types-color-img">
                <img appPreLoading
                  [lazyLoad]="highlight.imageList && highlight.imageList.length > 0 && highlight.imageList[0].path"
                  alt="img">
              </div>
              <span>{{highlight?.title}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- highlights section End  -->

  <!-- mobile section start  -->
  <section class="detail-authentic" *ngIf="website_product_configuration && website_product_configuration.length > 0">
    <div class="row highlight-new">
      <div class="col-6 mb-3" *ngFor="let wpc of website_product_configuration; let i = index;">
        <div class="authentic-detail-section">
          <div class="authentic-img">
            <img [src]="wpc.image" alt="icon">
          </div>
          <span> {{wpc.value}} </span>
        </div>
      </div>
    </div>

  </section>


  <!-- by now and add to cart section start  -->


  <!-- mobile for tab section start  -->
  <section class="tab-detail d-lg-none d-flex" id="home-tab-description">
    <div class="row w-100 m-0">
      <div class="col-12">
        <div class="tab-for-mobile">
          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item" role="presentation">
              <button (click)="changeSeletion('description')" class="nav-link active" id="home-tab" data-bs-toggle="tab"
                data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true"
                [ngStyle]="{'color':(descriptionOrHowToUseActive == 'description' && mProductModal?.category?.color) ? '#fff' : mProductModal?.category?.color,'background-color':(descriptionOrHowToUseActive == 'description' && mProductModal?.category?.color) ? mProductModal?.category?.color : ''}">Description</button>
            </li>
            <li class="nav-item" role="presentation">
              <button (click)="changeSeletion('howtouse')" class="nav-link" id="profile-tab" data-bs-toggle="tab"
                data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false"
                [ngStyle]="{'color':(descriptionOrHowToUseActive == 'howtouse' && mProductModal?.category?.color) ? '#fff' : mProductModal?.category?.color  ,'background-color':(descriptionOrHowToUseActive == 'howtouse' && mProductModal?.category?.color) ? mProductModal?.category?.color : ''}">how
                to use </button>
            </li>
          </ul>
          <div class="tab-content" id="myTabContent">

              <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab" *ngIf="mProductModal?.extras && mProductModal.extras.length > 0" [innerHTML]="selectedProductExtra?.description"></div>

              <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab" *ngIf="mProductModal?.extras && mProductModal.extras.length < 1" [innerHTML]="mProductModal?.description"></div>

            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab"
              [innerHTML]="mProductModal?.how_to_use_it"></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div id="recommenddetailnew">
    <section class="recommendations-mobile d-lg-none d-block">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-12 mb-4">
          <div class="recommendations-detail">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"
                    [style]="'background-color:'+mProductModal?.category?.color+';'"
                    [ngStyle]="{'color':(mProductModal?.category?.color) ? '#fff' : ''}">
                    KEY INGREDIENTS
                  </button>
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12 mb-4" *ngIf="mProductModal && mProductModal?.benifits">
          <div class="recommendations-detail">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFor">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFor"
                    aria-expanded="false" aria-controls="collapseFor"
                    [style]="'background-color:'+mProductModal?.category?.color+';'"
                    [ngStyle]="{'color':(mProductModal?.category?.color) ? '#fff' : ''}">
                    FEATURES & BENEFITS
                  </button>
                </h2>
                <div id="collapseFor" class="accordion-collapse collapse " aria-labelledby="headingFor"
                  data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <span class="detail-text" *ngIf="mProductModal && mProductModal.extras && mProductModal.extras.length > 0" [innerHTML]="selectedProductExtra?.benifits"></span>
                    <span class="detail-text" *ngIf="mProductModal.extras && mProductModal.extras.length < 1" [innerHTML]="mProductModal?.benifits"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>


  <!-- Foy Recommendations section start  -->

  <section class="recommendations" id="recommendationst">
    <div class="recommendations-t" *ngIf="recommends && recommends.length > 0">
      <h5><a (click)="recommendation()">Foy Recommendations</a></h5>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-12 mb-5">
        <div class="recommendations-detail">
          <div class="accordion" id="accordian1">
            <div class="accordion-item">
              <h2 class="accordion-header" id="d-accordian-one">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#d-accordian"
                  aria-expanded="false" aria-controls="d-accordian"
                  [style]="'background-color:'+mProductModal?.category?.color+';'">
                  Description
                </button>
              </h2>
              <div id="d-accordian" class="accordion-collapse collapse show" aria-labelledby="d-accordian-one"
                data-bs-parent="#accordian1">
                <div class="accordion-body">
                  <p *ngIf="mProductModal?.extras && mProductModal.extras.length > 0" [innerHTML]="selectedProductExtra?.description"></p>
                  <p *ngIf="mProductModal?.extras && mProductModal.extras.length < 1" [innerHTML]="mProductModal?.description"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12 mb-5">
        <div class="recommendations-detail">
          <div class="accordion" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                  aria-expanded="false" aria-controls="collapseTwo"
                  [style]="'background-color:'+mProductModal?.category?.color+';'">
                  How to use
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse show" aria-labelledby="headingTwo"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <p [innerHTML]="mProductModal?.how_to_use_it"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12 mb-4"
        *ngIf="mProductModal && mProductModal?.benifits && mProductModal.key_ingridents">
        <div class="recommendations-detail">
          <div class="accordion" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree"
                  aria-expanded="false" aria-controls="collapseThree"
                  [style]="'background-color:'+mProductModal?.category?.color+';'">
                  KEY INGREDIENTS
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse show" aria-labelledby="headingThree"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <p [innerHTML]="mProductModal?.key_ingridents"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-12 mb-4" *ngIf="mProductModal && mProductModal?.benifits">
        <div class="recommendations-detail">
          <div class="accordion" id="accordionExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingFor">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFor"
                  aria-expanded="false" aria-controls="collapseFor"
                  [style]="'background-color:'+mProductModal?.category?.color+';'">
                  FEATURES & BENEFITS
                </button>
              </h2>
              <div id="collapseFor" class="accordion-collapse collapse show" aria-labelledby="headingFor"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                  <span class="detail-text" *ngIf="mProductModal && mProductModal.extras && mProductModal.extras.length > 0" [innerHTML]="selectedProductExtra?.benifits"></span>
                  <span class="detail-text" *ngIf="mProductModal.extras && mProductModal.extras.length < 1" [innerHTML]="mProductModal?.benifits"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- key-ing-main START -->
  <section [id]="isMobile?'collapseThree':''" [ngClass]="isMobile?'accordion-collapse collapse show':''" *ngIf="mProductModal && !mProductModal?.benifits && mProductModal.key_ingredients_1"
    class="key-ing-main ">
    <div class="border-wrap">
      <div class="shop-wrap">
        <div class="row">
          <div class="col-lg-5 col-12 leftSide">
            <div class="key-new-img">
              <figure><img [src]="colorImageChange[0]?.path" /></figure>
            </div>
          </div>
          <div class="col-lg-7 rightSide">
            <div class="ing-details" [style]="'color:'+mProductModal?.category?.color+';'">
              <h4 [ngStyle]="{'color':(mProductModal?.category?.color) ? mProductModal?.category?.color : '#000'}">Key Ingredients</h4>
                <ul class="key-ingrediants" [innerHTML]="mProductModal.key_ingridents">
                <li></li>
              </ul>
              <a href="#" data-bs-toggle="modal" data-bs-target="#exampleModal" class="view-btn d-lg-block d-none">View All
                Ingredients</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="view-btn-detail-new d-lg-none d-flex">
      <a href="#" data-bs-toggle="modal" data-bs-target="#exampleModal" class="view-btn ">View All
        Ingredients</a>
    </div>
  </section>


<!-- mobile view Key Ingredients section start 06-12-2023 End  -->

  <!-- Foy Recommendations section End  -->
  <!-- foy recommends section start  -->
  <section id="f-recommendation" class="highlights" *ngIf="recommends && recommends.length > 0">
    <div class="row justify-content-center">
      <div class="foy-recommends" id="foy-recommends">
        <h5>foy recommends</h5>
      </div>
      <div class="col-lg-6 col-12">
        <div class="highlights-detail" [ngStyle]="{'overflow-x': recommends.length >= 3 ? 'auto' : '', 'justify-content': recommends.length <=3 ? 'center': ''}">
          <div class="col-3" *ngFor="let recommend of recommends; let i = index">
            <div class="skin-types-color">
              <div class="skin-types-color-g">
                <div class="skin-types-color-img">
                  <img appPreLoading
                    [lazyLoad]="recommend.imageList && recommend.imageList.length > 0 && recommend.imageList[0].path"
                    alt="img">
                </div>
              </div>
              <span>{{recommend?.title}}</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
  <!-- foy recommends section End  -->
  <!-- rating section start  -->
  <section class="rating">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-6 col-12">
        <div class="rating-header">
          <h5>customer Ratings</h5>
        </div>

        <div class="text-center d-lg-none  justify-content-center">
          <div class="single-chart">
            <svg viewBox="0 0 36 36" [attr.class]="'green'">
              <path class="circle-bg" d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831" />
              <path class="circle"
                [ngStyle]="{'stroke':(mProductModal?.category?.color) ? mProductModal?.category?.color : 'green'}"
                [attr.stroke-dasharray]="stroke" d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831" />
              <text x="18" y="20.35" class="percentage">{{reviewValue}}</text>
            </svg>
          </div>
        </div>

        <div class="rating-detail">
          <span class="rating-review text-center d-lg-none">{{productReviewData?.total_reviews}} Reviews</span>
          <div class="reting-star order-lg-1 order-2" *ngIf="reviewValue <= 0">
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="reting-star order-lg-1 order-2" *ngIf="reviewValue == 1">
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="reting-star order-lg-1 order-2" *ngIf="reviewValue > 1 &&  reviewValue <= 2">
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="reting-star order-lg-1 order-2" *ngIf="reviewValue > 2 &&  reviewValue <= 3">
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="reting-star order-lg-1 order-2" *ngIf="reviewValue > 3 &&  reviewValue <= 4">
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="reting-star order-lg-1 order-2" *ngIf="reviewValue > 4 &&  reviewValue <= 5">
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
            <i class="fa-solid fa-star" style="color: #FF8210;"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 col-12">
        <div class="row align-items-center">
          <div class="col-lg-4 d-lg-flex d-none">
            <div class="single-chart">
              <svg viewBox="0 0 36 36" [attr.class]="'green'">
                <path class="circle-bg" d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831" />
                <path class="circle"
                  [ngStyle]="{'stroke':(mProductModal?.category?.color) ? mProductModal?.category?.color : 'green'}"
                  [attr.stroke-dasharray]="stroke" d="M18 2.0845
                    a 15.9155 15.9155 0 0 1 0 31.831
                    a 15.9155 15.9155 0 0 1 0 -31.831" />
                <text x="18" y="20.35" class="percentage">{{reviewValue}}</text>
              </svg>
              <span class="rating-review text-center web-view">{{productReviewData?.total_reviews}} Reviews</span>
            </div>
          </div>
          <div class="col-lg-8 col-12">
            <div>
              <div class=" progress-detail">
                <div class="process-bar-text">
                  <span class="rating-number">5</span>
                  <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="0"
                    aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar" [ngStyle]="{'width': fiveRatingPercent+'%'}"></div>
                  </div>
                  <span class="rating-review">{{productReviewData?.five_rating}} Reviews</span>
                </div>
                <div class="process-bar-text">
                  <span class="rating-number">4</span>
                  <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="25"
                    aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar" [ngStyle]="{'width': fourRatingPercent+'%'}"></div>
                  </div>
                  <span class="rating-review">{{productReviewData?.four_rating}} Reviews</span>
                </div>
                <div class="process-bar-text">
                  <span class="rating-number">3</span>
                  <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="50"
                    aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar" [ngStyle]="{'width': threeRatingPercent+'%'}"></div>
                  </div>
                  <span class="rating-review">{{productReviewData?.three_rating}} Reviews</span>
                </div>
                <div class="process-bar-text">
                  <span class="rating-number">2</span>
                  <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="75"
                    aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar" [ngStyle]="{'width': twoRatingPercent+'%'}"></div>
                  </div>
                  <span class="rating-review">{{productReviewData?.two_rating}} Reviews</span>
                </div>
                <div class="process-bar-text">
                  <span class="rating-number">1</span>
                  <div class="progress" role="progressbar" aria-label="Basic example" aria-valuenow="100"
                    aria-valuemin="0" aria-valuemax="100">
                    <div class="progress-bar" [ngStyle]="{'width': oneRatingPercent+'%'}"></div>
                  </div>
                  <span class="rating-review">{{productReviewData?.one_rating}} Reviews</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- mobile section start  -->
  <section class="customer-reviews pb-lg-0 d-lg-none d-block" *ngIf="productReviews && productReviews.length > 0">
    <div class="row">
      <div class="customer-reviews-header">
        <h5>Customer Reviews</h5>
      </div>
      <owl-carousel-o class="categories-slider arrow-bg-remove" [options]="customerSlider">
        <ng-template carouselSlide *ngFor="let productReview of productReviews; let i = index">
          <div class="review-all">
            <div class="customer">
              <div class="customer-reviews-detail">
                <div class="customer-img">
                  <img src="assets/images/customer.png" alt="img">
                </div>
                <div class="customer-img-detail">
                  <h6>{{productReview?.username}}.</h6>
                  <small>Verified Buyer</small>
                  <span>{{productReview?.created_at | date: 'dd/MM/yy'}} </span>
                </div>
              </div>

            </div>
            <div class="customer-text-detail">
              <div class="customer-text">
                <span [style]="'color:'+mProductModal?.category?.color+';'">{{productReview?.title}}</span>
                <p  [innerHTML]="productReview?.description"></p>
              </div>
            </div>
            <div class="customer-star" *ngIf="productReview?.rating <= 0">
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
            </div>
            <div class="customer-star" *ngIf="productReview?.rating > 0 &&  productReview?.rating <= 1">
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
            </div>
            <div class="customer-star" *ngIf="productReview?.rating > 1 &&  productReview?.rating <= 2">
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
            </div>
            <div class="customer-star" *ngIf="productReview?.rating > 2 &&  productReview?.rating <= 3">
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-regular fa-star"></i>
              <i class="fa-regular fa-star"></i>
            </div>
            <div class="customer-star" *ngIf="productReview?.rating > 3 &&  productReview?.rating <= 4">
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-regular fa-star"></i>
            </div>
            <div class="customer-star" *ngIf="productReview?.rating > 4">
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
              <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            </div>
            <div class="helpful-yes-no">
              <div class="helpful">
                <span>Was this review helpful?</span>
              </div>
              <div class="yes-and-no-detail-text">
                <div class="Yes-detail" [ngClass]="userId != null && userId != '' ? '' : 'no-pointer-event'"
                  (click)="updateProductReview(productReview.id, true)">
                  <span>Yes</span>
                  <small>{{productReview?.likedProductReviewCount}}</small>
                </div>
                <div class="no-detail" [ngClass]="userId != null && userId != '' ? '' : 'no-pointer-event'"
                  (click)="updateProductReview(productReview.id, false)">
                  <span>No</span>
                  <small>{{productReview?.disLikedProductReviewCount}}</small>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </owl-carousel-o>
    </div>
  </section>
  <!-- rating section End  -->

  <!-- Customer Reviews section start  -->
  <section class="customer-reviews d-lg-block d-none" *ngIf="productReviews && productReviews.length > 0">
    <div class="row">
      <div class="customer-reviews-header">
        <h5> Customer Reviews</h5>
      </div>
      <div class="col-lg-6 col-md-6 col-12 mb-4" *ngFor="let productReview of productReviews; let i = index">
        <div class="review-all">
          <div class="customer">
            <div class="customer-reviews-detail">
              <div class="customer-img">
                <img src="assets/images/customer.png" alt="img">
              </div>
              <div class="customer-img-detail">
                <h6>{{productReview?.username}}.</h6>
                <small>Verified Buyer</small>
                <span>{{productReview?.created_at | date: 'dd/MM/yy'}}</span>
              </div>
            </div>
          </div>
          <div class="customer-text-detail">
            <div class="customer-text">
              <span [style]="'color:'+mProductModal?.category?.color+';'">{{productReview?.title}}</span>
              <p class="scrollbar-width-none" [innerHTML]="productReview?.description"></p>
            </div>
          </div>
          <div class="customer-star" *ngIf="productReview?.rating <= 0">
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="customer-star" *ngIf="productReview?.rating > 0 &&  productReview?.rating <= 1">
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="customer-star" *ngIf="productReview?.rating > 1 &&  productReview?.rating <= 2">
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="customer-star" *ngIf="productReview?.rating > 2 &&  productReview?.rating <= 3">
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-regular fa-star"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="customer-star" *ngIf="productReview?.rating > 3 &&  productReview?.rating <= 4">
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-regular fa-star"></i>
          </div>
          <div class="customer-star" *ngIf="productReview?.rating > 4">
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
            <i class="fa-solid fa-star" [style]="'color:'+mProductModal?.category?.color+';'"></i>
          </div>
          <div class="helpful-yes-no">
            <div class="helpful">
              <span>Was this review helpful?</span>
            </div>
            <div class="Yes-detail" [ngClass]="userId != null && userId != '' ? '' : 'no-pointer-event'"
              (click)="updateProductReview(productReview.id, true)">
              <span>Yes</span>
              <small>{{productReview?.likedProductReviewCount}}</small>
            </div>
            <div class="no-detail" [ngClass]="userId != null && userId != '' ? '' : 'no-pointer-event'"
              (click)="updateProductReview(productReview.id, false)">
              <span>No</span>
              <small>{{productReview?.disLikedProductReviewCount}}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- No Customer Reviews section start -->
  <div class="no-review">
    <div class="customer-reviews-header new-customer-text-add" *ngIf="productReviews && productReviews.length < 1">
      <h5> Customer Reviews</h5>
    </div>
    <div class="no-review-detail" *ngIf="productReviews && productReviews.length < 1">
      <span>there are no reviews</span>
      <small>please add a review</small>
    </div>
    <div class="read-btn">
      <ul>
        <li><a class="read-more-btn" *ngIf="productReviews && productReviews.length >= 1">Read More</a></li>
        
        <li><a *ngIf="userId!=null && userId!=''" class="add-r" data-bs-toggle="modal" data-bs-target="#addreview" (click)="selectedRatings(5)">ADD REVIEW</a>

          <a *ngIf="userId==null || userId==''" class="add-r" data-bs-toggle="modal" (click)="openLoginPopup(5)">ADD REVIEW</a></li>
      </ul>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade add-review-modal" id="addreview" tabindex="-1" aria-labelledby="addreviewLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered aad-r">
      <div class="modal-content add-review-modal-detail">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="closemodal()"
            aria-label="Close"></button>
        </div>
        <div class="add-reting">
          <h5 class="modal-title" *ngIf="!review" id="addreviewLabel">Add A review</h5>
          <h5 class="modal-title" *ngIf="review" id="addreviewLabel">Update A review</h5>

          <!-- star html start -->
          <div class="rating-review">
            <div class="rating p-0">
              <fieldset class="rating rating-fieldset p-0 m-0">
                  <input type="checkbox"  id="5-stars" name="rating" class="rating-checkbox" value="5" (click)="selectedRatings(5)"/>
                  <label for="5-stars" [ngClass]="selectedRating >= 5 ? 'full active' : ''"></label>
                  <input type="checkbox" id="4-stars" name="rating" value="4" class="rating-checkbox" (click)="selectedRatings(4)" />
                  <label for="4-stars" [ngClass]="selectedRating >= 4 ? 'full active' : ''"></label>
                  <input type="checkbox" id="3-stars" name="rating" value="3" class="rating-checkbox" (click)="selectedRatings(3)" />
                  <label for="3-stars" [ngClass]="selectedRating >= 3 ? 'full active' : ''"></label>
                  <input type="checkbox" id="2-stars" name="rating" value="2" class="rating-checkbox" (click)="selectedRatings(2)" />
                  <label for="2-stars" [ngClass]="selectedRating >= 2 ? 'full active' : ''"></label>
                  <input type="checkbox" id="1-stars" name="rating" value="1" class="rating-checkbox" (click)="selectedRatings(1)" />
                  <label for="1-stars" [ngClass]="selectedRating >= 1 ? 'full active' : ''"></label>
              </fieldset>
            </div>
          </div>

          <!-- star html end -->

          <form [formGroup]="reviewForm">
            <div class="add-comment-section">
              <div class="comment-detail-box mb-3">
                <input type="text" class="form-control-new" formControlName="title"
                  placeholder="Type your review Title here!">
                <div *ngIf="r['title'].touched && r['title'].invalid" class="validation-message">
                  <div *ngIf="r['title'].errors && r['title'].errors['required']">Title is required.</div>
                </div>
              </div>
              <div class="comment-detail-box comment-detail-box-two ">
                <textarea class="form-control-new" formControlName="description"
                  placeholder="Type your review description here!"></textarea>
                <div *ngIf="r['description'].touched && r['description'].invalid" class="validation-message">
                  <div *ngIf="r['description'].errors && r['description'].errors['required']">Description is required.
                  </div>
                </div>
              </div>
              <div class="add-new-btn">
                <button [disabled]="reviewForm.invalid" *ngIf="!review" (click)="addProductReview()" [ngClass]="{'no-pointer-events': isLoading, '': !isLoading}"> <i *ngIf="isLoading" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoading, '': !isLoading}"></i> SUBMIT</button>
                <button [disabled]="reviewForm.invalid" *ngIf="review"
                  (click)="updateProductReviewPage()" [ngClass]="{'no-pointer-events': isLoading, '': !isLoading}"> <i *ngIf="isLoading" class="fa me-1" [ngClass]="{'fa-spin fa-spinner': isLoading, '': !isLoading}"></i> SUBMIT</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <!-- No Customer Reviews section End -->


  <!-- shop similar section start  -->
  <section class="shop-similar" *ngIf="categoryProductList && categoryProductList.length > 0">
    <div class="row">
      <div class="col-12">
        <div class="shop-similar-header">
          <h5 [ngStyle]="{'color':( mProductModal?.category?.color) ? mProductModal?.category?.color : '#000'}">shop
            similar</h5>
          <span><a (click)="gotoShopAllOfCategory()">View all</a></span>
        </div>
      </div>
      <div class="arrow-btn">
        <div class="categories-slider-detail mb-lg-5 scrollbar" id="shop-similar-product" #similarProduct>
          <a class="left-arrow-btn"><img (click)="goLeft('shop-similar-product')" *ngIf="showSimilarLeftArrow"
              src="assets/images/left-arrow.png" alt=""></a>
              <ng-container *ngFor="let product of categoryProductList; let i  = index">
          <div class="col-lg-3 col-md-4 col-6" *ngIf="product.brand_id != brandId" >
            <div class="cetegories-slider-d" >
              <app-product-box-two [color]="product?.category?.color" [product]="product"
                [mAddUpdateCartModule]="mAddUpdateCartModule"
                [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse" [product]="product"
                [mAddUpdateCartModule]="mAddUpdateCartModule"
                [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse"
                [mWishlistData]="mWishlistData"></app-product-box-two>
            </div>
          </div>
        </ng-container>
          <a class="right-arrow-btn"><img (click)="goRight('shop-similar-product')" *ngIf="showSimilarRightArrow"
              src="assets/images/right-arrow.png" alt=""></a>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="brandProductList && brandProductList.length > 0">
      <div class="col-12">
        <div class="shop-similar-header">
          <h5 [ngStyle]="{'color':( mProductModal?.category?.color) ? mProductModal?.category?.color : '#000'}">MORE
            FROM {{brandName}}</h5>
          <span><a (click)="viewBrandDetail()">View all</a></span>
        </div>
      </div>
      <div class="arrow-btn">
        <div class="categories-slider-detail scrollbar" id="brand-product" #brandProduct>
          <a class="left-arrow-btn"><img (click)="goLeft('brand-product')" *ngIf="showBrandLeftArrow"
              src="assets/images/left-arrow.png" alt=""></a>
          <div class="col-lg-3 col-md-4 col-6" *ngFor="let product of brandProductList; let i  = index">
            <div class="cetegories-slider-d">
              <app-product-box-two [color]="product?.category?.color" [product]="product"
                [mAddUpdateCartModule]="mAddUpdateCartModule"
                [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse" [product]="product"
                [mAddUpdateCartModule]="mAddUpdateCartModule"
                [mAddUpdateCartModuleResponse]="mAddUpdateCartModuleResponse"
                [mWishlistData]="mWishlistData"></app-product-box-two>
            </div>
          </div>
          <a class="right-arrow-btn"><img (click)="goRight('brand-product')" *ngIf="showBrandRightArrow"
              src="assets/images/right-arrow.png" alt=""></a>
        </div>
      </div>
    </div>
  </section>

  <!-- shop similar section End  -->
</div>

<!-- Footer START -->
<app-footer-bg></app-footer-bg>

<!-- Footer END -->
<!-- pop START -->

<!-- Modal -->

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered key-in">
    <div class="modal-content bg-i">

      <div class="modal-body bg-modal-img-set">
        <div class="ingrediant-modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <h5 class="modal-title" id="exampleModalLabel" [style]="'color:'+mProductModal?.category?.color+';'">All
            Ingredients:</h5>
          <div [innerHTML]="mProductModal.key_ingredients_1" class="ingredient-t scrollbar-width-none"></div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="all-ingredients" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        <h4 class="modal-title" id="myModalLabel">All Ingredients:</h4>
      </div>
      <div class="modal-body">
        aqua (water). glycerin. coco-caprylate/ caprate. c15-19 alkane. cetearyl alcohol. macadamia ternifolia seed oil.
        butyrospermum parkii (shea) butter. caprylic/ capric triglyceride. tridecyl trimellitate. argania spinosa kernel
        oil. tapioca starch. glyceryl stearate. pentylene glycol. cetearyl glucoside.sodium acrylate/ sodium
        acryloydimethyl taurate copolymer. cera alba (beeswax). hydroxyacetophenone. sodium stearoyl glutamate. parfum
        (fragrance). acrylates/ c10-30 alkyl acrylate crosspolymer. bisabolol. tocopheryl acetate. polyglyceryl-6
        laurate.o-cymen-5 ol. microcitrus australasica fruit extract. polyglycerin-6. sorbitan oleate. sodium hydroxide.
        sorbitan isostearate. limonene.
      </div>
    </div>
  </div>
</div>

<div class="offcanvas offcanvas-bottom beach-bottom" tabindex="-1" id="offcanvasBottom"
  aria-labelledby="offcanvasBottomLabel">
  <div class="offcanvas-header soft-blur">
    <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body small">
    <h5 class="offcanvas-title soft-title" id="offcanvasBottomLabel">{{mProductModal?.name}}</h5>
    <div class="selectColor-beach">
      <span class="brach-detail">selected shade: <small
          [style]="'color:' +this.selectedProductExtra?.color+';'">{{this.selectedProductExtra?.color_name}}</small></span>
      <div class="beach-lease-img-detail">
        <ul>
          <li *ngFor="let color of colorList; let i = index" (click)="selectColor(color, true)"
            [ngClass]="activeColorId == color.id ? 'active' : ''" [ngStyle]="{'background': '' + color.color + ''}">

          </li>
        </ul>
      </div>
      <button class="done-btn-beach" data-bs-dismiss="offcanvas"
        (click)="selectColor(selectedProductExtra)">done</button>
    </div>
  </div>
</div>